import { LazyExoticComponent, lazy } from 'react';
import { env } from '@/config/env';

// The component type React.lazy accepts (ComponentType<any>), borrowed from its own
// signature so we don't have to write `any` ourselves to match the same bound.
type LazyLoad<T> = () => Promise<{ default: T }>;
type AnyLazyComponent = Parameters<typeof lazy> extends [LazyLoad<infer T>] ? T : never;

/**
 * Gate a devtool component behind {@link env.SHOW_DEVTOOLS}, lazy-loading it so the
 * package is code-split into its own async chunk and never fetched when the flag is off.
 *
 * The `load` thunk must contain an inline static-literal `import('@tanstack/...')` — Vite
 * only code-splits literal import specifiers, so the path cannot be parameterized.
 */
export function lazyDevtool<T extends AnyLazyComponent>(
  load: LazyLoad<T>
): LazyExoticComponent<T> | null {
  return env.SHOW_DEVTOOLS ? lazy(load) : null;
}
